import React from "react";

import { Trans } from "react-i18next";
import { VehicleWhite } from "../../../../Common/Buttons/Icons";

export const VehicleOverviewTopSection = ({ startExport, addVehicle }) => (
  <div className="titlebar">
    <div className="titlebar-left">
      <div className="left">
        <h1><Trans>Vehicle Overview</Trans></h1>
      </div>
    </div>
    <div className="titlebar-right">
      <div className="right">
        {/* Temporarily disabled until the export function can be configured for the new fxp server */}
        {/* TODO: [Export] Migrate feature to the new GQL server */}
        {/* <div className="desktop-action">
          <a className="button primary px-32 mr-8" onClick={() => startExport()}>
            <Trans>Export</Trans>
          </a>
        </div> */}
        <div className="desktop-action">
          <a className="button primary px-32" onClick={() => addVehicle()}>
            <span className="mr-8" style={{ verticalAlign: "sub" }}>{VehicleWhite()}</span>
            <Trans>Add Vehicle</Trans>
          </a>
        </div>
        <div className="mobile-action">
          <a className="button primary circle px-32" onClick={() => addVehicle()}>
            <span>{VehicleWhite()}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
);
